import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AuthCopyright from "../components/AuthCopyright";
import AreaBox from "../components/AreaBox";
import HeaderNav from "../components/HeaderNav";
import HeroArea from "../components/HeroArea";
import MainBox from "../components/MainBox";
import MainBoxTitleText from "../components/MainBoxTitleText";
import InvitationAcceptForm from "./components/InvitationAcceptForm";

export default function InvitationAccept() {
  const [title, setTitle] = useState<string>("買いログへようこそ。パスワードを再設定してください。");
  const [completeProcess, setCompleteProcess] = useState<boolean>(false);

  useEffect(() => {
    if (completeProcess) {
      setTitle("パスワード設定が完了しました。再度ログインして始めましょう！");
    }
  }, [completeProcess]);

  return (
    <>
      <HeaderNav />
      <AreaBox>
        <HeroArea />
        <MainBoxTitleText text={title} />
        <MainBox>
          {!completeProcess ? (
            <InvitationAcceptForm setCompleteProcess={setCompleteProcess} />
          ) : (
            <Link to="/auth/signIn" replace>
              ログインページへ移動
            </Link>
          )}
        </MainBox>
        <AuthCopyright />
      </AreaBox>
    </>
  );
}
